import { useHistory, useLocation } from "react-router-dom";

import { makeInternalRedirectState } from "features/common/routing/InternalRedirectOnlyRoute";

import ResetPasswordForm from "../password-reset-form/containers/ResetPasswordFormContainer";

export type Props = {
  pageNumber?: number;
  totalNumberOfPages?: number;
  linkToResetPasswordSignIn: string;
  linkToSignIn: string;
};

export default function ResetPassword({
  linkToResetPasswordSignIn,
  pageNumber,
  totalNumberOfPages,
  linkToSignIn
}: Props) {
  const history = useHistory();
  const location = useLocation();

  const onEmailSubmitSuccess = () => {
    history.push(
      makeInternalRedirectState({
        pathname: linkToResetPasswordSignIn,
        state: location.state
      } as any)
    );
  };

  return (
    <ResetPasswordForm
      pageNumber={pageNumber}
      totalNumberOfPages={totalNumberOfPages}
      signInLink={{
        pathname: linkToSignIn,
        state: location.state,
        search: location.search
      }}
      onEmailSubmitSuccess={onEmailSubmitSuccess}
    />
  );
}
